/* LV 23.09.2026: strzalki paska "Warto przetestowac" w koszyku bocznym.
   Globalnie, bo motyw wstawia zawartosc koszyka przez innerHTML i skrypty z sekcji sie nie wykonuja. */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-lv-dosp]') : null;
    if (!b) return;
    e.preventDefault();
    var ul = b.closest('.lv-dosprzedaz').querySelector('ul');
    if (!ul) return;
    var li = ul.querySelector('li');
    ul.scrollBy({ left: (li ? li.offsetWidth : ul.clientWidth) * Number(b.getAttribute('data-lv-dosp')), behavior: 'smooth' });
  });
})();

/* LV 23.09.2026: przycisk X w polach wyszukiwania (burger menu i szuflada filtrow).
   Czysci pole i wysyla zdarzenie input, wiec oba skrypty same wracaja do pelnej listy. */
(function () {
  document.addEventListener('click', function (e) {
    var x = e.target.closest ? e.target.closest('.lv-szukaj-x') : null;
    if (!x) return;
    e.preventDefault();
    var pole = x.parentNode.querySelector('input[type="search"]');
    if (!pole) return;
    pole.value = '';
    pole.dispatchEvent(new Event('input', { bubbles: true }));
    pole.focus();
  });
})();


/* lv-kotwica-dobor: Shopify wycina id z tresci polityk, wiec kotwice #dobor-pielegnacji
   w regulaminie nadajemy tutaj (link ze spisu tresci i z ankiety pielegnacyjnej). */
(function () {
  if (location.pathname.indexOf('/policies/terms-of-service') === -1) return;
  var h = Array.prototype.find.call(document.querySelectorAll('.shopify-policy__body h1, .shopify-policy__body h2'),
    function (el) { return /Regulamin us.ugi Dob.r piel.gnacji/i.test(el.textContent); });
  if (!h) return;
  h.id = 'dobor-pielegnacji';
  h.style.scrollMarginTop = '120px';
  if (location.hash === '#dobor-pielegnacji') setTimeout(function () { h.scrollIntoView(); }, 50);
})();
